module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACMAAAA1CAYAAADLVlLfAAAAAXNSR0IArs4c6QAAAHxJREFUWEft2bEJgEAQRFGvg73+i7wSFERMxGACcYNnLHp8H5M4qmrfmlyj5WHWWr/1mXOe777LOMz1LZR5Q6mMMulgMcMMM2kBZtJidoYZZtICzKTF7AwzzKQFmEmL2RlmmEkLMJMWszPMMJMWYCYt9tiZ9AFf3N/qt+ABdArR8amBgRsAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/page/crop/two-to-three.png
// module id = f5Fw
// module chunks = 3